import { render, staticRenderFns } from "./Enigma3.vue?vue&type=template&id=2020bc49&scoped=true&"
import script from "./Enigma3.vue?vue&type=script&lang=js&"
export * from "./Enigma3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020bc49",
  null
  
)

export default component.exports